import { Field, reduxForm } from 'redux-form';
import { LoginButton, LoginButtonDisabled } from '../../components/buttons';
import React, { Component } from 'react';
import { isValidName, renderTextField } from '../../components/reduxFields';
import { connect } from 'react-redux';
import { checkBusinessName, forgotPasswordAction } from './actions/LoginActions';
import { NavLink, Redirect } from 'react-router-dom';
import { subDomainUrlRedirection } from '../../actions/utilAction';
// import history from '../../history';
// import validate from './validate';
import Favicon from 'react-favicon';
import LogoImageViewer from '../../components/logoImageViewer'; 


class ForgotPassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // errorMessage: null,
    };
  }

  componentWillMount() {
    let subdomain = subDomainUrlRedirection();
    if (subdomain) {
      this.props.checkBusinessName(subdomain);
    }
  }

  onSubmit(authData) {
    // authData.ResetPasswordURL = `${window.location.origin}/reset-password` ; // Commented this code on 01/23/2022 after pen testing
    //authData.ResetPasswordURL = `${window.location.origin}` ; // Commented this code on 01/23/2022 after pen testing //Jerry
    // console.log('forgotpassData---', authData);
    this.props.forgotPasswordAction(authData, this.props.businessNameCheck);
  }

  MailConfirmation = (message) => (
    <div className="login-fields text-center">
      <div className="resetmail_msg">
        <i className="material-icons">email</i>

        <p>{message}</p>
        {/* <p>A confimation email sent to your mail with reset password link.Thanks!</p> */}

      </div>
    </div>
  );

  renderLoading() {
    return (
      <div className="login_bg">
        <div className="login-wrapper">
          <div className="login-fields">
          Loading...Please wait !
          </div>
        </div>
      </div>);
  }

  renderForm(props) {
    const { handleSubmit } = props;
    return (
      <div className="login-fields">
        <h3>Forgot Password </h3>
        <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))}>
          {props.errorMessage ?
            (<div className="alert-danger">{props.errorMessage}</div>)
            : '' }
          <div className="row">
            <div className="col-md-12 require">
              <Field
                name="userName"
                type="text"
                maxLength="60"
                normalize = {isValidName}
                label="User name"
                component={renderTextField} />
            </div>
          </div>
          <div className="mt-30">
            {props.authenticating ? <LoginButtonDisabled label="Submit" /> : <LoginButton label="Submit" />}
          </div>
          <p className="frgtcont">Please enter username.</p>
          <div className="backtologin text-center"><NavLink exact to="/login"><i className="fa fa-long-arrow-left" aria-hidden="true"></i> Back to Login</NavLink></div>
        </form>
      </div>
    );
  }

  render() {

    const { loaderBusinessToken, authenticatingToken, businessNameCheck } = this.props;
    let logoUrl = this.props.organizationLogoBase64 && `data:image/png;base64,${this.props.organizationLogoBase64}`;

    // console.log(loaderBusinessToken, businessNameCheck)
    if (loaderBusinessToken || authenticatingToken) {
      this.renderLoading();
    } else if (!businessNameCheck) {
      return (<Redirect to="/login" />);
    }
    return (
      <div className="login_bg_WithGradient">
        <div className="login-wrapper">
          <Favicon url={this.props.organizationDetails && this.props.organizationDetails.favicon ? this.props.organizationDetails.favicon : ''} />
          <div className="loginlogo">
            <LogoImageViewer isLoginPage={true} logoUrl={logoUrl} businessName={this.props.businessName} />
          </div>
          { this.props.successMessage ?
            this.MailConfirmation(this.props.successMessage) :
            this.renderForm(this.props)
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loaderBusinessToken: state.login.loaderBusinessToken,
    businessNameCheck: state.login.businessNameCheck,
    businessName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    organizationLogoBase64: state.login.organizationDetails && state.login.organizationDetails.logoBase64,
    authenticating: state.login.authenticating,
    errorMessage: state.login.errorMessage,
    successMessage: state.login.successMessage,
    organizationDetails: state.login.organizationDetails,
  };
}

function validate(values) {
  const error = {};
  if (!values.userName || values.userName.trim() === '') {
    error.userName = 'Please enter user name';
  }
  return error;
}

ForgotPassword = reduxForm({
  form: 'ForgotPasswordForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(ForgotPassword);

export default connect(mapStateToProps, { forgotPasswordAction, checkBusinessName })(ForgotPassword);



// WEBPACK FOOTER //
// ./src/modules/logins/forgot_password.js